import React from 'react';
import { Route } from 'react-router-dom';
import NotAuthorized from './NotAuthorized.jsx';

const routes = [
  <Route key="not-authorized" path="/not-authorized"><NotAuthorized/></Route>
];

export default routes;
